import { connect } from 'react-redux';

import AccessDenied from './component';

const mapStateToProps = null;

const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccessDenied);
